module.exports = __webpack_public_path__ + "static/img/cont45_05.2b32321.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45_05.jpg
// module id = iO4A
// module chunks = 0